const { Plugin } = require('@uppy/core')
const { Provider } = require('@uppy/companion-client')

module.exports = class Vimeo extends Plugin {
  constructor(uppy, opts) {
    super(uppy, opts)
    this.id = 'Vimeo'
    Provider.initPlugin(this, opts)
    this.title = this.opts.title || 'Vimeo'
    this.icon = () => ''
    this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders || this.opts.serverHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: 'Vimeo',
      pluginId: this.id,
    })

    this.render = this.render.bind(this)
  }

  render() {
    const button = document.querySelector('.v-toolbar__items > button')
    button.click()
    return window.open(
      'https://chrome.google.com/webstore/detail/panda-video/feocfomniclchbgaioedfhccgckmlbed',
      'chrome'
    )
  }
}
